/* template */
<template minapp="mpx" xlang="wxml"><div class="mpx-root-view"><controllable-drawer-bottom :title="(recommendTicketDrawer.title)" :show="(show)" @close="close"><recommend-ticket-card :recommendTicketDrawer="(recommendTicketDrawer)" :style="[({'padding-top': '37px', 'padding-bottom': '25px'})] | transRpxStyle"/><div class="pay-container"><div class="price"><div class="order-money"><div class="order-money-type">￥</div><div class="order-money-num">{{
              recommendTicketDrawer.afterPrice == recommendTicketDrawer.price
                ? recommendTicketDrawer.price
                : (recommendTicketDrawer.afterPrice || '0')
            }}</div></div><div class="discount-area" v-if="(recommendTicketDrawer.afterPrice != recommendTicketDrawer.price)"><div class="discount-desc" v-if="(recommendTicketDrawer.desc)">{{
            recommendTicketDrawer.desc
          }}</div><crossed-price :price="(Number(recommendTicketDrawer.price))" class="original-price"/></div></div><mpx-view @tap="toMakeOrder" class="btn">预定</mpx-view></div></controllable-drawer-bottom><Privacy :list="(baichuanTrainPrivacy)" @privacyVerify="privacyVerify" v-if="(showPrivacy)"/></div></template>

/* styles */
<style scoped lang="stylus" mpxStyleOptions='{"mid":"m1b229ef4"}'>
  @import '~@/mixins/stylus/color.styl'

  .recommend-drawer
    // display flex
    padding 37px 16px 24px
    font-family PingFang SC
    font-size 14px
    font-weight 500
    color #222222
  .info
    display flex
    align-items center
    justify-content space-between
    width 100%
    margin-bottom 21px
  .left
    display flex
    align-items center
  .tag
    background #338FFF
    margin-right 8px
    border-radius 4px
    color #FFFFFF
    font-size 12px
    padding 3.5px 5px
  .tips
    padding 10px 12px
    font-size 12px
    background #F2F6F9
    border-radius 12px
    margin-top 20px
  .pay-container
    height 100px
    padding 11px 14px 0 16px
    box-shadow inset 0px 1px 0px 0px #EEEEEE
    border-radius 10px 10px 0px 0px
    display flex
    justify-content space-between
    align-items baseline
  .price
    color #FF6400
    font-size 32px
    font-weight 500
    display flex
    align-items baseline
    flex-direction column
    font-family Barlow Semi Condensed
    font-weight 400
    &-symbol
      font-size 16px
      font-weight normal
    .discount-area
      display flex
      margin-top 4px
      align-items center
      .discount-desc
        font-family PingFangSC-Regular
        font-size 10px
        font-weight normal
        line-height 10px
        color #FF6400
        margin-right 4px
      .original-price
        font-family PingFangSC-Regular
        font-size 10px
        font-weight normal
        line-height 10px
        color #999
  .btn
    width 140px
    height 50px
    background #FF6400
    color #FFFFFF
    font-size 16px
    font-weight 800
    display flex
    align-items center
    justify-content center
    border-radius 10px
  .order-money
    line-height 32px
    display flex
    align-items flex-end
    color #FF6400
    .order-money-type
      font-family PingFangSC-Semibold
      font-size 16px
      line-height 16px
      transform translateY(-4px)
    .order-money-num
      font-family Barlow Semi Condensed
      font-size 32px
      font-weight 400
      &-personal
        color #FF7D41
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m1b229ef4"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./drawer.mpx.js?isComponent&outputPath=components%2Fdrawer1b229ef4%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./drawer.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Fdrawer1b229ef4%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m1b229ef4"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/drawer1b229ef4/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'controllable-drawer-bottom':getComponent(require("../controllable-drawer-buttom.mpx?isComponent&outputPath=components%2Fcontrollable-drawer-buttomcb57d2b4%2Findex")),'crossed-price':getComponent(require("../crossed-price/index.mpx?isComponent&outputPath=components%2Findex1220e10f%2Findex")),'Privacy':getComponent(require("../../pages/train-detail/components/privacy/index.mpx?isComponent&outputPath=components%2Findex6f368ef8%2Findex")),'recommend-ticket-card':getComponent(require("./recommend-ticket-card.mpx?isComponent&outputPath=components%2Frecommend-ticket-card14bd2c2b%2Findex")),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
